import React from 'react';

function FeaturesCard(props) {
  return (
    <>
      <div className='features_card_icon d-flex align-items-center justify-content-center'>
        {props.svg}
      </div>
      <div className='title'>
        <h3 className='text-subtitle'>
          {props.title} <br />
          {props.title2}
        </h3>
      </div>
      <p className='text-gray'>
        {props.subtitle} <br />
        {props.subtitle2} <br />
        {props.subtitle3}
      </p>
    </>
  );
}

export default FeaturesCard;
